<div class="mb-0 px-3">
  <h5 class="fw-bold headings-primary mb-0">
    Welcome Back, {{ full_name }}
  </h5>

  <p class="text-white text-xxs">
    Here's your Department of Basic Education progress summary.
  </p>
</div>
